import { Employee, UserRule } from "@finway-group/shared/lib/models"

import { CostCenter2Service, CostCenterService, ExpenseAccountService } from "Shared/services"

export const getInitialEmployeeRule = (employee: Employee | undefined, companyIdParam: string): Pick<UserRule, "costCenter" | "costCenter2" | "expenseAccount"> => {
    const rule = employee?.rule?.find(({ companyId }) => companyId === companyIdParam)

    return {
        // Empty strings for fallback value in the forms
        costCenter: CostCenterService.getCostCenterById(rule?.costCenter)?._id ?? "",
        costCenter2: CostCenter2Service.getCostCenter2ById(rule?.costCenter2)?._id ?? "",
        expenseAccount: ExpenseAccountService.getExpenseAccountById(rule?.expenseAccount)?._id ?? "",
    }
}
